import { ApiService } from "./api.service";
import type { IInstanceInfo } from "@/types/instance";

export class InstanceService extends ApiService {
  async getInstanceInfo(): Promise<IInstanceInfo> {
    return this.get("/api/instances/");
  }
}
